import "./App.css";
import { ConfigProvider } from "antd";
import Router from "./router";
import { AppContextProvider } from "./context/AppContext";
import { APIProvider } from '@vis.gl/react-google-maps';
import { GoogleOAuthProvider } from "@react-oauth/google";

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY!;
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID!;

function App() {
  return (
    <AppContextProvider>
      <GoogleOAuthProvider clientId={CLIENT_ID}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#096dd9",
              fontFamily: `'Montserrat', sans-serif`,
              colorHighlight: "rgb(231, 242, 247)",
              blue: "#096dd9",
              colorInfoHover: "rgb(231, 242, 247)",
              colorInfoActive: "rgb(231, 242, 247)",
              colorPrimaryActive: "rgb(231, 242, 247)",
            },
          }}
        >
          <APIProvider apiKey={googleMapsApiKey} libraries={['places']}>
            <Router />
          </APIProvider>
        </ConfigProvider>
      </GoogleOAuthProvider>
    </AppContextProvider>
  );
}

export default App;
